import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Welcome from '../views/Welcome.vue'
import Login from '../views/Login.vue'
import Tracking from '../views/Tracking.vue'
import Aviso from '../views/Aviso.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    meta: {
      title: 'Inicio'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/tracking',
    name: 'Tracking',
    component: Tracking,
    meta: {
      title: 'Tracking'
    }
  },
  {
    path: '/aviso-de-privacidad',
    name: 'Aviso',
    component: Aviso,
    meta: {
      title: 'Aviso de Privacidad'
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
